import type { INavData } from '@coreui/angular-pro';


export const navItemsSuperadmin: INavData[] = [
  {
    name: 'Home',
    url: '/dashboard',
    iconComponent: { name: 'cil-home' },
  },
  {
    name: 'Pacientes',
    url: '/patient/list',
    iconComponent: { name: 'cil-people' },
  },
  {
    name: 'Médicos',
    url: '/doctor/list',
    iconComponent: { name: 'cil-people' },
  },
  {
    name: 'Instituciones',
    url: '/institution/list',
    iconComponent: { name: 'cil-building' },
  },
  {
    name: 'Órdenes ERKOM 3D',
    iconComponent: { name: 'cil-clipboard' },
    url: '/erkom/list',
  },
  {
    name: 'Usuarios',
    url: '/users',
    iconComponent: { name: 'cil-user' },
  },
 /* {
    name: 'Fabricante',
    iconComponent: { name: 'cil-factory' },
    url: '/manufacturer/list',
  },
  {
    name: 'Regiones',
    iconComponent: { name: 'cil-location-pin' },
    url: '/regions/list',
  },

  {
		name: 'Estudios',
		url: '/studies',
    iconComponent: { name: 'cil-clipboard' },
  },*/
];
